import { render, staticRenderFns } from "./to_be_supplied.vue?vue&type=template&id=2670ea42"
import script from "./to_be_supplied.vue?vue&type=script&lang=js"
export * from "./to_be_supplied.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports